var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"header":"Produtos de limpeza","text":"Durante o agendamento você pode escolher entre o profissional levar os produtos básicos para a limpeza ou ele utilizar os produtos de sua preferência que você tem disponíveis no local.","imagePath":"/static/dashboard/cleaning-products.svg","inverted":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5a16f0c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/components/InfoCards/cards/Products.vue
// module id = null
// module chunks = 